module.exports = __webpack_public_path__ + "static/media/Nokia Asha 230 Black.73523c71.png";